angular.module('app.directives.forms.std_controls', [])

  /**** Orange Form Title */
  .directive('stdOrangeTitle', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      template: " " +
      "<div class='row col-lg-8 col-md-8 col-sm-12 col-xs-12'>" +
      "  <div class='static-popover-style-bg ng-isolate-scope' static-popover={{text}}>" +
      "    <div class='static-popover-style-bg-top'>" +
      "      <h2 ng-bind='title' class='ng-binding'>{{text}}</h2>" +
      "    </div>" +
      "    <div class='static-popover-style-bg-bottom'>" +
      "      <i class='glyphicon glyphicon-play'></i>" +
      "    </div>" +
      "   </div>" +
      "</div>"
      ,
      scope: {
        text: '@',
        format: '@'
      },
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])

   .directive('stdFormInfo', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   template: " "+
     "<div class='col-lg-8 col-md-8 col-sm-12 col-xs-12'>"+
     "  <div ng-repeat='item in form_info'>" +
     "    <div class='row'>" +
     "      <p>{{item}}</p>" +
     "    </div>" +
     "  </div>" +
     "</div>",
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

  .directive('stdErrorDisplay', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      template: " "+
      "<div class='form-rest-response row col-lg-12 col-md-12 col-sm-12 col-xs-12'>"+
      "   <div ng-show='(responsemessage && responsemessage.length > 0)'>"+
      "     <div ng-repeat='message in responsemessage'>" +
      "       <div class='row'>" +
      "         <p>{{message}}</p>" +
      "       </div>" +
      "   </div>" +
      "   <div class='detail' ng-show='(responsedetail && responsedetail.length > 0)'>"+
      "       <div ng-repeat='detail in responsedetail'>" +
      "         <div class='row'>" +
      "           <p>{{detail}}</p>" +
      "         </div>" +
      "     </div>" +
      "   </div>" +
      "   <p ng-class='has-error' ng-if='saveError'>{{ saveError }}</p>"+
      "</div>",
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])

   .directive('stdFirstname', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
     templateUrl: 'templates/forms/std-firstname.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

   .directive('stdLastname', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-lastname.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

   .directive('stdAddress', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-address.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

   .directive('stdCity', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-city.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

  .directive('stdState', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      templateUrl: 'templates/forms/std-state.html',
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])

   .directive('stdZipcode', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-zipcode.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

   .directive('stdPhone', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-phone.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

   .directive('stdEmail', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-email.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

   .directive('stdSsn4', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-ssn4.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

  .directive('stdAcctnum', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      templateUrl: 'templates/forms/std-acctnum.html',
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])


  .directive('stdComments', ['$log', '$window', function ($log, $window) {
   'use strict';
   return {
   templateUrl: 'templates/forms/std-comments.html',
   replace: true,
   transclude: true,
   restrict: 'AE',
   link: function (scope, element, attrs) {
   }
   };
   }])

  .directive('stdDob', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      templateUrl: 'templates/forms/std-dob.html',
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])

  .directive('stdSubmit', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      template: " "+
      "<div class='row col-lg-6 col-md-6 col-sm-6 col-xs-6'>" +
      "  <button class='btn btn-default btn-primary std-form-btn' ng-disabled='defaultForm.$invalid' ng-click='if (resetForm) resetForm();' type='submit' ng-transclude>" +
  /*    "  <button class='btn btn-default btn-primary std-form-btn'type='submit' ng-transclude></button>" + */
      "</div>",
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])

  .directive('stdSearch', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      template: " "+
      "<div class='row col-lg-6 col-md-6 col-sm-12 col-xs-12 well well-sm'>" +
      "  <button class='btn btn-default btn-primary btn-lg' ng-disabled='defaultForm.$invalid' type='submit' ng-transclude>" +
        /*    "  <button class='btn btn-default btn-primary std-form-btn'type='submit' ng-transclude></button>" + */
      "</div>",
      replace: true,
      transclude: true,
      restrict: 'AE',
      link: function (scope, element, attrs) {
      }
    };
  }])


;
